import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isAuthenticated } from '../../utils/auth'

const PrivateRoute: React.FC = () => {
  const authenticated = isAuthenticated()

  return authenticated ? <Outlet /> : <Navigate to="/login" replace />
}

export default PrivateRoute
